import { catchError, filter, switchMap } from 'rxjs/operators';
import { concat, from, of } from 'rxjs';
import axios from 'axios-observable';
import { PayloadEpic } from '@/store/epics/epic-types';
import { actions, asyncActions } from '@/store/slices';
import { apiEndpoints } from '@/store/constants';
import { PublicInvoiceModel } from '@/models';
import { UpdateInvoiceWarehousePayload } from '@/store/slices/staff/invoices.slice';

export const updateInvoiceWarehouseEpic: PayloadEpic<UpdateInvoiceWarehousePayload, PublicInvoiceModel[]> = (
    action$
) => {
    return action$.pipe(
        filter(asyncActions.staffInvoices.updateWarehouse.match),
        switchMap(({ payload }) =>
            concat(
                of(actions.staffInvoices.setIsSaving(true)),
                updateInvoiceWarehouse(payload).pipe(
                    switchMap(({ data }) => from([actions.staffInvoices.setSavingErrors(null)])),
                    catchError((error) => {
                        console.error('updateInvoiceWarehouseEpic', error);

                        return of(actions.staffInvoices.setSavingErrors(error.response.data));
                    })
                ),
                of(actions.staffInvoices.setIsSaving(false))
            )
        )
    );
};

const updateInvoiceWarehouse = (data: UpdateInvoiceWarehousePayload) => {
    return axios.post<PublicInvoiceModel>(apiEndpoints.staffInvoiceChangeWarehouse(data.invoice), data);
};
